var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "sm" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative h-32" }, [
              _c("div", { staticClass: "w-full space-y-1" }, [
                _c("p", { staticClass: "font-bold text-base" }, [
                  _vm._v("Submit time"),
                ]),
                _c("p", [
                  _vm._v(
                    " You are logging " +
                      _vm._s(_vm.toMinutes(_vm.time)) +
                      " minutes for " +
                      _vm._s(_vm.activityTitle) +
                      ". Is this correct? "
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "w-full flex justify-end mt-5 gap-4",
                  attrs: { id: "decline-buttons" },
                },
                [
                  _c("UiButton", {
                    attrs: {
                      disabled: false,
                      variant: "outline",
                      buttonText: "Go back",
                      processing: _vm.processing,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal(false)
                      },
                    },
                  }),
                  _c("UiButton", {
                    attrs: {
                      disabled: _vm.reason === "",
                      variant: "black",
                      buttonText: "Yes",
                      processing: _vm.processing,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal(true)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }